import type { CompanyCustomer, CompanyCustomerProduct } from "model/Company";
import { useState } from "react";
import { Api } from "services/api/api.service";

type SaveCustomerProductParams = {
  companyId?: number;
  product: CompanyCustomerProduct;
};

type UseCustomerProductsResult = {
  isSavingProduct: boolean;
  saveCustomerProduct(
    params: SaveCustomerProductParams,
  ): Promise<readonly CompanyCustomer[] | null>;
};

export const useCustomerProducts = (): UseCustomerProductsResult => {
  const [isSavingProduct, setIsSavingProduct] = useState(false);

  const saveCustomerProduct = async ({
    companyId,
    product,
  }: SaveCustomerProductParams): Promise<readonly CompanyCustomer[] | null> => {
    if (!companyId) {
      return null;
    }

    setIsSavingProduct(true);

    try {
      await Api().company.addCompanyCustomerProduct(companyId, product);
      const result = await Api().company.getCompanyCustomers(companyId);
      return result.data;
    } catch {
      return null;
    } finally {
      setIsSavingProduct(false);
    }
  };

  return {
    isSavingProduct,
    saveCustomerProduct,
  };
};
